import { DOCUMENT_DISPLAY_TYPE } from "@/config/const";

export default {
  documentRootPath: null,
  vesselName: null,
  isDocumentSidebarActive: true,
  isDocumentSidebarClickNotClose: true,
  isContentInfoSidebarActive: false,
  selectedContentViewStyle: DOCUMENT_DISPLAY_TYPE.GRID,
  documents: {
    files: [],
    folders: []
  },
  displayDocuments: {
    files: [],
    folders: []
  },
  folders: [],
  moveDialogFolders: [],
  documentSearchQuery: null,
  currentPath: [],
  isSelectedAllFile: false,
  selectedDocument: null,
  selectedDocuments: [],
  documentNewPath: null,
  isSearching: false,
  selectedSidebarItem: null,
  showFolderList: true,
  searchDocumentsRange: "current",
  selectedMoveDialogFolderPath: "",
  showListCardPath: false,
  selectedSidebarText: null,
  storageMaxCapacity: null,
  storageUsage: null,
  isSortOrderAsc: true,
  sortKey: "name",
};
